var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4485_36402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 33.3489C60.0027 32.911 59.7764 32.5035 59.4032 32.2745H59.3967L59.3732 32.2614L39.9686 20.7749C39.8848 20.7183 39.7978 20.6666 39.7081 20.62C38.9589 20.2334 38.0689 20.2334 37.3196 20.62C37.2299 20.6666 37.1429 20.7183 37.0591 20.7749L17.6546 32.2614L17.6311 32.2745C17.0381 32.6433 16.8562 33.423 17.225 34.0161C17.3337 34.1909 17.4834 34.3364 17.6611 34.4402L37.0657 45.9267C37.1498 45.9829 37.2367 46.0346 37.3262 46.0817C38.0754 46.4683 38.9654 46.4683 39.7147 46.0817C39.8041 46.0346 39.891 45.9829 39.9751 45.9267L59.3798 34.4402C59.7674 34.2142 60.0041 33.7976 59.9996 33.3489Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9167 25.6794H32.6508V37.3522H19.9167V25.6794ZM57.395 13.8139V8.47441C57.4256 7.1394 56.3689 6.03199 55.0339 6H21.9887C20.6537 6.03199 19.597 7.1394 19.6276 8.47441V13.8139L39.1625 19.0232L57.395 13.8139Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6279 13.8145H32.6512V25.5354H19.6279V13.8145Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6746 13.8145H32.6514V25.5354L45.6746 37.2563H57.3956V25.5354L45.6746 13.8145Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6514 25.5352H45.6746V37.2561H32.6514V25.5352Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6514 37.2559H45.6746V48.9768H32.6514V37.2559Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.917 37.3516H32.6511V47.9629H19.917V37.3516Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6748 37.2559H57.3957V48.9768H45.6748V37.2559Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4037 34.3693L59.3789 34.3824L39.9743 45.2958C39.8896 45.3479 39.8037 45.3974 39.7138 45.4417C39.3842 45.5986 39.0263 45.6872 38.6616 45.7022L37.6015 45.0822C37.5119 45.0373 37.4249 44.9873 37.341 44.9325L17.6759 33.7091H17.6668L17.0234 33.3496V55.4423C17.0335 56.9162 18.2361 58.1031 19.7101 58.0938H57.3551C57.3773 58.0938 57.3968 58.0834 57.4202 58.0834C57.7316 58.0635 58.0385 57.9994 58.3318 57.8932C58.4586 57.8395 58.581 57.7759 58.6978 57.7031C58.7851 57.6536 58.9348 57.5455 58.9348 57.5455C59.602 57.0519 59.9968 56.2722 60.0001 55.4423V33.3496C59.9997 33.7722 59.7718 34.1618 59.4037 34.3693Z",
    fill: "url(#paint0_linear_4485_36402)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.9579 33.2608V34.6152L38.6677 48.5852L17.6612 33.7166C17.6612 33.7094 17.6553 33.7035 17.6481 33.7035L15.7207 32.5445V31.5677L16.5151 31.5547L18.1951 32.5184L18.2342 32.5314L18.3774 32.6226C18.3774 32.6226 38.1206 43.8877 38.1728 43.9138L38.9281 44.3565C38.9932 44.3305 39.0583 44.3044 39.1365 44.2784C39.1755 44.2523 58.7364 33.2477 58.7364 33.2477L58.9579 33.2608Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4037 34.3693L59.3789 34.3836L39.9743 45.2971C39.8896 45.3492 39.8037 45.3987 39.7138 45.443C38.9602 45.8111 38.0789 45.8111 37.3253 45.443C37.2361 45.3988 37.1492 45.3501 37.0648 45.2971L17.6603 34.3836L17.6368 34.3693C17.2622 34.1662 17.0273 33.7758 17.0234 33.3496V55.4423C17.0328 56.916 18.235 58.1031 19.7087 58.0938C19.7087 58.0938 19.7088 58.0938 19.7088 58.0938H57.3147C58.7885 58.1032 59.9908 56.9161 60.0001 55.4424C60.0001 55.4424 60.0001 55.4423 60.0001 55.4423V33.3496C59.9997 33.7722 59.7718 34.1618 59.4037 34.3693Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.2571 45.1348L39.9667 45.2976C39.8825 45.3511 39.7956 45.4003 39.7062 45.4447C39.3863 45.6018 39.0384 45.6939 38.6826 45.7156L46.0655 54.4464L58.9442 57.5498C59.2971 57.2833 59.5778 56.9327 59.7608 56.5301L40.2571 45.1348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M41.5725 44.3945L39.9667 45.297C39.8825 45.3506 39.7956 45.3998 39.7062 45.4442C39.3863 45.6012 39.0384 45.6933 38.6826 45.7151L42.1416 55.252L58.9481 57.5454C59.6102 57.0483 60 56.2688 60.0003 55.4408V55.1556L41.5725 44.3945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7453 58.0938H57.3108C57.8889 58.0967 58.4526 57.9141 58.9192 57.5728L37.6001 45.0849C37.5106 45.0399 37.4236 44.9899 37.3397 44.9351L17.6746 33.7117H17.6655L17.0234 33.3496V55.3667C17.022 56.8714 18.2406 58.0923 19.7453 58.0938Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.256 18.8051V46.5837C35.2537 47.5577 34.6615 48.4331 33.7583 48.7977C33.4785 48.9179 33.1772 48.98 32.8727 48.98H17.0234V17.7203H19.6281V16.418H32.8728C34.1884 16.423 35.2531 17.4894 35.256 18.8051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.9537 20.108V47.8865C33.9569 48.2011 33.8902 48.5125 33.7583 48.7981C33.3966 49.6896 32.5325 50.2745 31.5704 50.2789H17.0234V17.7208H31.5704C31.9483 17.717 32.3207 17.8113 32.6513 17.9943C33.4497 18.3965 33.9534 19.2141 33.9537 20.108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.9537 20.108V45.2819C33.9473 46.597 32.8855 47.6629 31.5704 47.6743H17.0234V17.7208H31.5704C31.9483 17.717 32.3207 17.8113 32.6513 17.9943C33.4497 18.3965 33.9534 19.2141 33.9537 20.108Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.6513 20.1079V45.2818C32.6499 46.5989 31.5852 47.6677 30.2681 47.6741H17.0234V17.7207H30.2681C31.585 17.7214 32.652 18.7896 32.6513 20.1066C32.6513 20.107 32.6513 20.1074 32.6513 20.1079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38715 17.7207H30.264C31.5824 17.7207 32.6511 18.7895 32.6511 20.1079V43.9847C32.6511 45.3031 31.5824 46.3718 30.264 46.3718H6.38715C5.06875 46.3718 4 45.303 4 43.9847V20.1079C4 18.7895 5.06878 17.7207 6.38715 17.7207Z",
    fill: "url(#paint1_linear_4485_36402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4607 27.7327C12.0491 26.4791 12.9987 25.4301 14.1878 24.7204C15.5046 23.9665 17.0039 23.5907 18.5206 23.6343C19.9264 23.6038 21.3135 23.9601 22.5305 24.6644C23.6747 25.3468 24.5963 26.3466 25.1833 27.5425C25.8226 28.8603 26.1412 30.3106 26.1132 31.7751C26.1442 33.3055 25.8163 34.822 25.156 36.203C24.555 37.4417 23.6042 38.4771 22.4211 39.1814C21.1572 39.9072 19.7186 40.273 18.2615 40.2389C16.8257 40.2735 15.408 39.9131 14.163 39.197C13.0089 38.5138 12.0758 37.5128 11.475 36.3137C10.8319 35.0149 10.5095 33.5809 10.5348 32.1319C10.508 30.6145 10.8245 29.1106 11.4607 27.7327ZM14.3675 34.8043C14.6812 35.5968 15.2131 36.284 15.9016 36.7864C16.6029 37.2766 17.4426 37.5294 18.2979 37.5079C19.2087 37.5439 20.1066 37.2825 20.8557 36.763C21.5354 36.2622 22.0534 35.573 22.3455 34.7808C22.672 33.8961 22.8332 32.9589 22.8209 32.016C22.831 31.0641 22.6795 30.1173 22.3729 29.216C22.102 28.4023 21.6008 27.6848 20.9299 27.1505C20.1996 26.6065 19.3042 26.3305 18.3943 26.3691C17.5204 26.3465 16.6619 26.6014 15.942 27.0971C15.2419 27.6016 14.6998 28.295 14.3792 29.0962C13.668 30.9327 13.6643 32.9678 14.3688 34.8069L14.3675 34.8043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6748 13.8145H57.3957V25.5354H45.6748V13.8145Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4485_36402",
    x1: 38.5118,
    y1: 33.3496,
    x2: 38.5118,
    y2: 58.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4485_36402",
    x1: 8.97728,
    y1: 15.8554,
    x2: 27.6739,
    y2: 48.2371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4485_36402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 52.093,
    fill: "white",
    transform: "translate(4 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.bf4603c23b77cfb2394fa5a671c96cbc.svg";
export { ForwardRef as ReactComponent };